import { render } from "./ObjectAddTemplate.vue?vue&type=template&id=8131ce1c"
import script from "./ObjectAddTemplate.vue?vue&type=script&lang=js"
export * from "./ObjectAddTemplate.vue?vue&type=script&lang=js"

import "./ObjectAddTemplate.vue?vue&type=style&index=0&id=8131ce1c&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.4.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__